import { Switch, Form, Input, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from "react-i18next"

const timeFormats = [
    { label: '24 Hour (HH:mm)', value: 'HH:mm' },
    { label: '24 Hour with Seconds (HH:mm:ss)', value: 'HH:mm:ss' },
    { label: '12 Hour (hh:mm AM/PM)', value: 'hh:mm A' },
    { label: '12 Hour with Seconds (hh:mm:ss Am/PM)', value: 'hh:mm:ss A' },
    { label: 'Hour Only (HH)', value: 'HH' },
    { label: 'Minute Only (mm)', value: 'mm' }
]

const TimeForm = ({ formValues, form }) => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item name="label" label={t("Label")}>
                <Input placeholder={t("Enter label")} />
            </Form.Item>

            <Form.Item name="placeholder" label={t("Placeholder")}>
                <Input placeholder={t("Enter placeholder")} />
            </Form.Item>

            <Form.Item name="tooltip" label={t("Tooltip")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t("Enter help text")} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t("Mandatory")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t("Read Only")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t("Hide Initially")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="currentTime" label={t("Current Time")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="timeFormat" label={t("Time Format")}>
                <Select 
                    options={timeFormats.map(f => ({ ...f, label: t(f.label) }))} 
                    defaultValue="HH:mm"
                    placeholder={t("Select time format")}
                />
            </Form.Item>

            {/* <Form.Item name="showSeconds" label={t("Show Seconds")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="use12Hours" label={t("12 Hour Format")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item> */}

            <Form.Item name="allowClear" label={t("Allow Clear")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="showNow" label={t("Show Now Button")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="realTime" label={t("Real Time Update")} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="minuteStep" label={t("Minute Step")}>
                <Select 
                    options={[
                        { label: '1 minute', value: 1 },
                        { label: '5 minutes', value: 5 },
                        { label: '10 minutes', value: 10 },
                        { label: '15 minutes', value: 15 },
                        { label: '30 minutes', value: 30 }
                    ]}
                    defaultValue={1}
                    placeholder={t("Select minute step")}
                />
            </Form.Item>

            <Form.Item name="hourStep" label={t("Hour Step")}>
                <Select 
                    options={[
                        { label: '1 hour', value: 1 },
                        { label: '2 hours', value: 2 },
                        { label: '3 hours', value: 3 },
                        { label: '6 hours', value: 6 },
                        { label: '12 hours', value: 12 }
                    ]}
                    defaultValue={1}
                    placeholder={t("Select hour step")}
                />
            </Form.Item>

            <Form.Item name="secondStep" label={t("Second Step")}>
                <Select 
                    options={[
                        { label: '1 second', value: 1 },
                        { label: '5 seconds', value: 5 },
                        { label: '10 seconds', value: 10 },
                        { label: '15 seconds', value: 15 },
                        { label: '30 seconds', value: 30 }
                    ]}
                    defaultValue={1}
                    placeholder={t("Select second step")}
                />
            </Form.Item>

        </>
    )
}

export default TimeForm